import http from '../utils/http';
import i18n from '@/main';

const baseUrl = '/compartilhamento-dados';

export default {
    requestCompartilhamentoDados(body, { page, size, sort }) {
        return http.post({
            url:
                baseUrl + `/filtrar?page=${page - 1}&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoCompartilhamentoDeDados')
        });
    },

    cadastrarCompartilhamentoDados(territorios) {
        return http.post({
            url: baseUrl + `/cadastrar`,
            data: territorios,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.solicitandoRelatorio')
        });
    },

    downloadResultado(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `${baseUrl}/download/${id}`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoResultadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    downloadShape(id) {
        return http.get({
            url: baseUrl + `/shape/${id}`,
            responseType: 'blob',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.preparandoShapeParaDownload')
        });
    }
};
